import request from "../utils/request";

/**
 * CAPI API wrapper
 */
export const CAPI_API = {
    /**
     * Channel için mevcut dataset'leri listeler
     * @param {string} channelId - Channel ID
     * @returns {Promise}
     */
    listDatasets(channelId) {
        return request({
            url: `/channel/${channelId}/capi/datasets`,
            method: "get",
        });
    },

    /**
     * Yeni dataset oluşturur
     * @param {string} channelId - Channel ID
     * @returns {Promise}
     */
    createDataset(channelId) {
        return request({
            url: `/channel/${channelId}/capi/dataset`,
            method: "post",
        });
    },

    /**
     * CAPI event gönderir
     * @param {string} channelId - Channel ID
     * @param {string} visitorId - Visitor ID
     * @param {string} eventType - Event type
     * @param {Object} customData - Custom data
     * @param {number} eventTime - Event time (unix timestamp)
     * @returns {Promise}
     */
    sendEvent(channelId, contactId, eventType, customData, eventTime = null) {
        return request({
            url: `/channel/${channelId}/capi/send-event`,
            method: "post",
            data: {
                contactId,
                eventType,
                customData,
                eventTime,
            },
        });
    },

    /**
     * CAPI bağlantısını test eder
     * @param {string} channelId - Channel ID
     * @returns {Promise}
     */
    testConnection(channelId) {
        return request({
            url: `/channel/${channelId}/capi/test-connection`,
            method: "post",
        });
    },
};

export default CAPI_API;



